import { useInitialPublicData } from '../seo/PublicBootstrap.jsx';
import { useState, useEffect } from "react";
import { fetchHomepageListings as apiFetchListings } from "../services/api";

export function useListings() {
  const initial = useInitialPublicData("listings");
  const [listings, setListings] = useState(initial || []);
  const [loading, setLoading] = useState(!initial);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (initial) { setListings(initial); setLoading(false); return undefined; }
    let cancelled = false;

    apiFetchListings()
      .then((data) => {
        if (!cancelled) setListings(data.carouselListings || []);
      })
      .catch((err) => {
        if (!cancelled) {
          console.error("Error fetching listings:", err);
          setListings([]);
          setError(err?.message || "Unable to load listings right now.");
        }
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => { cancelled = true; };
  }, [initial]);

  return { listings, loading, error };
}
